module.exports = __webpack_public_path__ + "img/NTT_EAST_EN_CorporateSymbol_A1_4C.de58cdfd.svg";